import React from 'react';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { WordShape } from '../shapes';
import WordHeader from './word/header';

export default class LoggedOutTackConfirmation extends React.Component {

  static propTypes = {
    userConfirmed: PropTypes.bool,
    word: WordShape,
    params: PropTypes.object,
  }

  render() {
    let confirmationText;
    if (this.props.userConfirmed) {
      confirmationText = "Done! Check your inbox to for the magic link to login. Once you do, we'll start your tack."
    } else {
      confirmationText = 'Right on! Check your inbox to confirm your email address and start tacking.';
    }
    return (
      <Fragment>
        <div className='word'>
          <WordHeader wordText={ this.props.params.wordText } pronunciationFile={ this.props.word.get('pronunciationFile') } partOfSpeech={ this.props.word.get('partOfSpeech') } />
        </div>
        <div className='row logged-out-tack-confirmation'>
          <div className='col-sm-12'>
            { confirmationText }
          </div>
          <div className='col-sm-12 action'>
            <Link to='/' className='btn btn-dark' data-primary-cta='true'>Got It</Link>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/logged_out_tack_confirmation.jsx